import {Component, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-pdf-page',
    templateUrl: './pdf-page.component.html',
    styleUrls: ['./pdf-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PdfPageComponent {
}
